/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UsagePlanResponse } from '../../models/usage-plan-response';

export interface GetUsagePlan$Params {
  'Active-Tenant-Identifier': string;
}

export function getUsagePlan(http: HttpClient, rootUrl: string, params: GetUsagePlan$Params, context?: HttpContext): Observable<StrictHttpResponse<UsagePlanResponse>> {
  const rb = new RequestBuilder(rootUrl, getUsagePlan.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UsagePlanResponse>;
    })
  );
}

getUsagePlan.PATH = '/usage-plan';
